import styled from 'styled-components';
import { useCallback, useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import { exactWhite } from '../../../utils/style/colors';
import { message } from './message';
import * as FileUtils from '../../../utils/file';
import { isInWhiteList } from '../../../utils/fileUtils';
import { ITEM_MIN_ORDER } from '../../../store/providers/providerTypes';
import { useDispatch } from 'react-redux';
import { creatingNewProviderItem } from '../../../store/providers/providerSlice';

const DragDropContainer = styled(Dropzone)`
  width: 100%;
  height: 70rem;
  position: absolute !important;
  top: 0;
  left: 0;
  z-index: ${(props) => (props.zind ? '1000' : '-10')};
  color: 'var(--exact-white)';
  background: rgba(10, 10, 10, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: bold;
`;

function DragDropFileUpload({ providerId, dataItemId }) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();

  const addFilesHandler = (files) => {
    if (files) {
      for (const ind in files) {
        const fileReader = new FileReader();
        fileReader.onload = () => {
          const fileUrl = URL.createObjectURL(files[ind]);
          const fileType = FileUtils.detectFileType(fileReader, files[ind]);
          const analyseFileType = FileUtils.analyseFileType(fileType);
          let displayName = files[ind].name;
          const dotIndex = displayName.lastIndexOf('.');
          displayName = displayName.substring(0, dotIndex);
          let error;
          if (!isInWhiteList(files[ind].type)) {
            error = { data: { message: 'canNotViewInMobile' } };
          }
          dispatch(
            creatingNewProviderItem({
              providerId: providerId,
              dadId: dataItemId,
              dataUrl: fileUrl,
              fileSize: files[ind].size,
              displayName: displayName,
              format: analyseFileType.type,
              photo: analyseFileType.isPhoto,
              order: ITEM_MIN_ORDER,
              originalFileName: files[ind].name,
              error: error,
            })
          );
        };
        fileReader.readAsArrayBuffer(files[ind].slice(0, 20));
        setSelectedFiles((prevState) => {
          return [...prevState, files[ind]];
        });
      }
    }
    setSelectedFiles([]);
  };

  const onDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsVisible(() => true);
  }, []);
  const onDragLeave = useCallback((e) => {
    setIsVisible(() => false);
    e.stopPropagation();
    e.preventDefault();
  }, []);
  const onDrop = useCallback(() => {
    setIsVisible(() => false);
  }, []);

  useEffect(() => {
    window.addEventListener('mouseup', onDragLeave);
    window.addEventListener('dragover', onDragOver);
    window.addEventListener('drop', onDrop);

    return () => {
      window.addEventListener('mouseup', onDragLeave);
      window.addEventListener('dragover', onDragOver);
      window.addEventListener('drop', onDrop);
    };
  }, []);

  return (
    <>
      {isVisible ? (
        <DragDropContainer
          multiple={true}
          onDropRejected={() => {
            setSelectedFiles([]);
          }}
          onDropAccepted={(files) => {
            addFilesHandler(files);
          }}
          zind={isVisible}
        >
          {message.dropHere}
        </DragDropContainer>
      ) : (
        <div></div>
      )}
    </>
  );
}
export default DragDropFileUpload;
